enum storageKey {
    USER_LANGUAGE_KEY = "USER_LANGUAGE_KEY"
}

export default storageKey